// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
  index(context, params) {
    const { sortBy, sortDesc, page, rowsPerPage } = params.pagination
      ? params.pagination
      : [null, null, null, null];
    context.commit("set_loading");

    const sort = [];
    if(sortBy && sortBy.length){
      for (let idx = 0; idx < sortBy.length; idx++) {
        let s = sortDesc[idx]?'-':'';
        s += sortBy[idx]
        sort.push(s);
      }
    }

    const filters = params.filter || {}
    if(params.search){
      filters.search = params.search
    }

    return new Promise(resolve => {
      NewApiService.get("clients", {
        page: page,
        sort: sort.join(","),
        rowsPerPage: rowsPerPage,
        filter: filters
      })
        .then(({ data }) => {
          context.commit("set_clients", data);
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  listXperience(context, params) {
    const { sortBy, sortDesc, page, rowsPerPage } = params.pagination
      ? params.pagination
      : [null, null, null, null];
    context.commit("set_loading");


    const sort = [];
    if(sortBy && sortBy.length){
      for (let idx = 0; idx < sortBy.length; idx++) {
        let s = sortDesc[idx]?'-':'';
        s += sortBy[idx]
        sort.push(s);
      }
    }

    const filters = params.filter || {}
    if(params.search){
      filters.search = params.search
    }

    return new Promise(resolve => {
      NewApiService.get("clients/xperience", {
        page: page,
        sort: sort.join(","),
        rowsPerPage: rowsPerPage,
        filter: filters
      })
        .then(({ data }) => {
          context.commit("set_clients2", data);
          context.commit("unset_loading");
          resolve(data);
        })
    });
  },
  view(context, params) {
    context.commit("set_loading");
    const fields = params.fields ? params.fields : "";
    const expand = params.expand ? params.expand : "";
    return new Promise(resolve => {
      NewApiService.get("clients/" + params.id, {
        fields: fields,
        expand: expand
      })
        .then(({ data }) => {
          resolve(data.client);
        })
        .finally(() => {
          context.commit("unset_loading");
        });
    });
  },
  add(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.post("clients", params)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  update(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.put(`clients/${params.id}`, params)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },

  getCredits(context, params){
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("clients/" + params.clientId + "/credits/"+params.currency)
        .then(({ data }) => {
          resolve(data);
        })
        .finally(() => {
          context.commit("unset_loading");
        });
    });
  },
  
  getDownloadList(context, clientId) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("clients/"+clientId+"/download-invoices")
        .then(({ data }) => {
          context.commit("unset_loading");
          context.commit("setDownloadList", data);
          resolve(data);
        })
        .catch(({ response }) => {
          if(response)
            context.commit("set_error", response.data.errors);
        });
    });
  },
  createDownloadInvoice(context, model){
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.post("clients/"+model.clientId+"/download-invoices", model)
        .then(({ data }) => {
          context.commit("unset_loading");
          context.commit("setDownloadList", data);
          resolve(data);
        })
        .catch(({ response }) => {
          if(response)
            context.commit("set_error", response.data.errors);
        });
    });
  },
  downloadZip(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get(
        "clients/"+params.clientId+"/download-invoices/" + params.id,
        {},
        { responseType: "blob" }
      )
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  getMailchimpList(context, clientId) {
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.get(
        `clients/${clientId}/mailchimp`,
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
        }).finally(() => {
          context.commit("unset_loading");
        })
    });
  }
};
